var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('div',{staticClass:"ceng",style:({height: _vm.scrollerHeight, width: _vm.scrollerWidth})}),_c('div',{style:({height: _vm.scrollerHeight, width: _vm.scrollerWidth}),attrs:{"id":"bai-du-map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }